import {subscribe} from 'dna-react-ioc'
import {ApplicationStepsStore} from './ApplicationStepsStore'
import {IApplicationStepsStore} from './IApplicationStepsStore'
import {ONBOARDING_STORE_SYMBOLS} from './symbols'

export const getApplicationStepsStore = (): ApplicationStepsStore => {
    return subscribe<ApplicationStepsStore>(ONBOARDING_STORE_SYMBOLS.ApplicationStepsStore)
}

export const useApplicationStepsStore = (): IApplicationStepsStore => {
    return subscribe<IApplicationStepsStore>(ONBOARDING_STORE_SYMBOLS.ApplicationStepsStore)
}
